import { render, staticRenderFns } from "./CompanyVision.vue?vue&type=template&id=28cd2077&scoped=true&"
import script from "./CompanyVision.vue?vue&type=script&lang=ts&"
export * from "./CompanyVision.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyVision.vue?vue&type=style&index=0&id=28cd2077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd2077",
  null
  
)

export default component.exports